import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {Link} from '@mui/material'
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';

const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;




const AboutUsCard = () => {

    // const handleDownloadReceipt = (filename, Displayname,ext) => {
    //     const link = document.createElement('a');
    //     link.href = `${REACT_APP_EXPRESS_SERVER}/getguide/${filename}`;
    //     link.download = `${Displayname}.${ext}`;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };
    const handleDownloadReceipt = async (filename, Displayname, ext) => {
    const server = process.env.REACT_APP_EXPRESS_SERVER;
    try {
        const response = await fetch(`${server}/getguide/${filename}`);
        if (!response.ok) throw new Error('Download failed');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;
        link.download = `${Displayname}.${ext}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        alert('File could not be downloaded.');
        console.error(error);
    }
    };
    
    return (
            <Card sx={{ elevation: 3 }} elevation={3}>
            <CardActionArea>
                <CardMedia
                component="img"
                height="230"
                image="https://jms.co.ug/wp-content/uploads/2023/03/slider_1.jpg"
                alt="joint medical store "
                />
                <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    About the Joint Medical Store Bidding System
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    The <b>Joint Medical Store (JMS) Bidding System </b> is a transparent and efficient platform 
                    designed to streamline the procurement of medical supplies and equipment. It enables suppliers 
                    to participate in competitive bidding, ensuring fairness, accountability, and value in healthcare
                    procurement. With real-time updates, secure transactions, and a user-friendly interface, the 
                    system allows suppliers to browse bids, submit proposals, and track their progress with ease. 
                    Committed to integrity and efficiency, JMS ensures that the procurement process remains accessible,
                    competitive, and aligned with industry standards to support quality healthcare services.
                </Typography>
                {/* <Typography sx={{ mt: 2, color:'red' }}>Download Guide Videos</Typography> */}
                {/* <Typography variant="body2" sx={{ mt: 2 }}> */}
                {/* <button onClick={()=>handleDownloadReceipt('2025-05-29-08-28-47-Signup.mkv','Signup','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8',paddingLeft:'0px'}}>
                    1.Sign Up,
                </button>
                <button onClick={()=>handleDownloadReceipt('2025-05-29-09-43-59-Login.mkv','Login','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8'}}>
                    2.Login, 
                </button>
                <button onClick={()=>handleDownloadReceipt('2025-06-10-09-30-10-Validation.mkv','ProfileValidation','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8'}}>
                    3.Profile Validation, 
                </button>
                <button onClick={()=>handleDownloadReceipt('2025-05-30-10-58-00-proof-of-Validation.mkv','Proof-of-Validation','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8'}}>
                    4.Proof of Payment, 
                </button>
                
                <button onClick={()=>handleDownloadReceipt('2025-05-30-11-09-13-Create-Bid.mkv','Create-Bid','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8'}}>
                    5.Create Bid, 
                </button>
                <button onClick={()=>handleDownloadReceipt('2025-06-10-10-29-39-Excel.mkv','Excel','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8'}}>
                    6.Excel
                </button>
                <button onClick={()=>handleDownloadReceipt('2025-06-02-12-24-26-Upload.mkv','Upload Bid','mkv')} style={{outLine:'none',border:'none',background:'none',color:'#1A73E8'}}>
                    7.Upload Bid
                </button> */}
                
               
        {/* </Typography> */}
                </CardContent>
            </CardActionArea>
            <CardActions>
            {/* <Button size="small" color="primary">
            Share
            </Button> */}
        </CardActions>
        </Card>
    )
}

export default AboutUsCard;